import { jsx as s } from "react/jsx-runtime";
import "@smart/web-foundations";
import t from "react";
const o = t.createContext(
  void 0
), i = ({
  theme: e,
  children: r
}) => {
  const [m, n] = t.useState(e ?? "light");
  return /* @__PURE__ */ s(o.Provider, { value: { theme: e ?? m, setTheme: n }, children: r });
};
i.displayName = "ThemeContextProvider";
const c = () => {
  const e = t.useContext(o);
  return e || {
    theme: "light",
    setTheme: () => {
    }
  };
};
export {
  i as T,
  c as u
};
//# sourceMappingURL=theme-context.BfIZgriR.js.map
